var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-header'),_c('router-view'),_c('notification-bar'),_c('password-expire-notification-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }